import React, { FC } from "react";

import { Button } from "@mui/material";

import { WhiteLinkIcon } from "@/assets/icons";
import { useSecuredUrl } from "@/shared/hooks";
import { InsurerLink } from "@/shared/utils";

import { StyledInvocationFrame, StyledLinkButtonGroup } from "./styled";

type InsurerLinkPanelProps = {
    insurerLinks: InsurerLink[];
    insurer: MyBrokerApi.Company;
    description: string;
};
const InsurerLinkPanel: FC<InsurerLinkPanelProps> = ({ insurerLinks, insurer, description }) => {
    const { onSecureUrlClick } = useSecuredUrl();
    const insurerFsma = insurer?.fsma ? `(${insurer?.fsma})` : "";

    if (!insurerLinks.length) return <> </>;

    return (
        <StyledInvocationFrame data-testid="invocation_frame">
            <div className="companyImage">
                <img src={insurer.logoUrl} alt={`${insurer.name}${insurerFsma}`} />
            </div>
            <span className="description">{description}</span>
            <StyledLinkButtonGroup>
                {insurerLinks.map(({ link, label }) => (
                    <Button
                        key={link}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            onSecureUrlClick(link);
                        }}
                        data-testid={`invocation_frame-button-${link}`}
                    >
                        <WhiteLinkIcon /> {label}
                    </Button>
                ))}
            </StyledLinkButtonGroup>
        </StyledInvocationFrame>
    );
};

export default InsurerLinkPanel;
